import React from "react";
import { AdminLogin } from "./admin/Login";
import { AdminDashboard } from "./admin/Dashboard";
import { EventList } from "./admin/EventList";
import { CreateEventWizard } from "./admin/CreateEventWizard";
import { FormBuilder } from "./admin/FormBuilder";
import { WorkflowBuilder } from "./admin/WorkflowBuilder";
import { EventDashboard } from "./admin/EventDashboard";
import { Applications } from "./admin/Applications";
import { ApplicationDetail } from "./admin/ApplicationDetail";
import { Jury } from "./admin/Jury";
import { JuryEvaluation } from "./admin/JuryEvaluation";
import { CertificateDesigner, ResultsManagement } from "./admin/ResultsCertificate";
import { ArchivePage, AuditPage, NotificationsPage, ReportsPage, RolesPage } from "./admin/Operations";
import { ApplicationRecord, View } from "../types/system";
export { AdminLogin };
type Props = {
  view: View;
  onNavigate: (v: View) => void;
  applications: ApplicationRecord[];
  updateStatus: (status: ApplicationRecord["status"], stage: string, score?: number) => void;
  published: boolean;
  onPublish: () => void;
};
export function AdminPages({
  view,
  onNavigate,
  applications,
  updateStatus,
  published,
  onPublish
}: Props) {
  switch (view) {
    case "dashboard":
      return <AdminDashboard onNavigate={onNavigate} data-id="element-1200" data-mp="3nxbd91x6jlbr" />;
    case "events":
      return <EventList onNavigate={onNavigate} data-id="element-1201" data-mp="3j4s0262ems7h" />;
    case "create":
      return <CreateEventWizard onNavigate={onNavigate} data-id="element-1202" data-mp="1oifafjia5ki" />;
    case "form-builder":
      return <FormBuilder onNavigate={onNavigate} data-id="element-1203" data-mp="1qmtprf16mz1" />;
    case "workflow":
      return <WorkflowBuilder onNavigate={onNavigate} data-id="element-1204" data-mp="3su1onby1hsqu" />;
    case "event-dashboard":
      return <EventDashboard onNavigate={onNavigate} data-id="element-1205" data-mp="apgln4hf2p69" />;
    case "applications":
      return <Applications onNavigate={onNavigate} applications={applications} data-id="element-1206" data-mp="5q3xmget7c23" />;
    case "application-detail":
      return <ApplicationDetail applications={applications} updateStatus={updateStatus} data-id="element-1207" data-mp="2cgbi7yjg6se1" />;
    case "jury":
      return <Jury onNavigate={onNavigate} data-id="element-1208" data-mp="27hql47zhsott" />;
    case "jury-evaluation":
      return <JuryEvaluation updateStatus={updateStatus} data-id="element-1209" data-mp="27jl77pmi2mzh" />;
    case "results":
      return <ResultsManagement published={published} onPublish={onPublish} data-id="element-1210" data-mp="bfwucjaj706o" />;
    case "certificate":
      return <CertificateDesigner data-id="element-1211" data-mp="gdypw3p58rz1" />;
    case "archive":
      return <ArchivePage data-id="element-1212" data-mp="lcrt93apv2lh" />;
    case "reports":
      return <ReportsPage data-id="element-1213" data-mp="lbqiz11iyk4t" />;
    case "notifications":
      return <NotificationsPage data-id="element-1214" data-mp="pe509gpjpbtz" />;
    case "roles":
      return <RolesPage data-id="element-1215" data-mp="pewi7oq7zb1s" />;
    case "audit":
      return <AuditPage data-id="element-1216" data-mp="pbs9ce1t7r4s" />;
    default:
      return <AdminDashboard onNavigate={onNavigate} data-id="element-1217" data-mp="udpw3i9f542h" />;
  }
}